/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MedicalFormSubmitted/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function MedicalFormSubmitted({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/SetupAction/Content/Content/Content/Steps/Content/ActiveStep/Automation/Event/MedicalFormSubmitted"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 text="This automation will trigger when any medical form is submitted."
/>
{children}
</React.Fragment>)
}